import { useEffect } from "react";
import { StickyBar } from "@/components/landing/StickyBar";
import { Hero } from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import { Products } from "@/components/landing/Products";
import { WhyChoose } from "@/components/landing/WhyChoose";
import { Ordering } from "@/components/landing/Ordering";
import { ExportShipping } from "@/components/landing/ExportShipping";
import { Trust } from "@/components/landing/Trust";
import { LeadForm } from "@/components/landing/LeadForm";
import { Faq } from "@/components/landing/Faq";
import { Footer } from "@/components/landing/Footer";
import { FloatingWhatsApp } from "@/components/landing/FloatingWhatsApp";
import { ChatWidget } from "@/components/landing/ChatWidget";
import { Seo } from "@/components/Seo";
import { scrollToId } from "@/lib/vgt";

export default function LandingPage() {
  useEffect(() => {
    if (window.location.hash) {
      const id = window.location.hash.slice(1);
      const t = setTimeout(() => scrollToId(id), 500);
      return () => clearTimeout(t);
    }
  }, []);

  return (
    <div data-testid="landing-page" className="bg-[#FDFBF7] text-[#2C1A0C] font-sans min-h-screen">
      <Seo
        title="Indonesian Vanilla Supplier | Vanilla Global Transindo (VGT)"
        description="Premium Indonesian vanilla beans supplied direct to global B2B buyers — bakeries, food manufacturers, gelato & chocolate makers. Request a quotation from VGT."
        path="/"
      />
      <StickyBar />
      <main>
        <Hero />
        <Marquee />
        <Products />
        <WhyChoose />
        <Ordering />
        <ExportShipping />
        <Trust />
        <LeadForm />
        <Faq />
      </main>
      <Footer />
      <FloatingWhatsApp />
      <ChatWidget />
    </div>
  );
}
